const RTL_LOCALES = ['he', 'ar', 'fa', 'ur', 'yi'];

export function isRTLLocale(locale: string): boolean {
  return RTL_LOCALES.includes(locale);
}

export function getTextDirection(locale: string): 'ltr' | 'rtl' {
  return isRTLLocale(locale) ? 'rtl' : 'ltr';
}

/**
 * Normalizes a locale string to valid BCP 47 (e.g. `en_il` → `en-IL`).
 * Falls back to `'en'` when the tag is missing or invalid.
 */
export function normalizeLocale(locale?: string): string {
  if (!locale) return 'en';
  try {
    const { baseName } = new Intl.Locale(locale.replace(/_/g, '-'));
    // Intl reads a bare `pt` as Brazilian; our `pt` messages are European Portuguese.
    return baseName === 'pt' ? 'pt-PT' : baseName;
  } catch {
    return 'en';
  }
}

export function buildAvailableLocaleSet(
  availableLocales: readonly string[] | null | undefined,
  filterSet?: ReadonlySet<string>,
): Set<string> {
  const lowered = availableLocales?.map(l => l.toLowerCase()) ?? [];
  return new Set(filterSet ? lowered.filter(l => filterSet.has(l)) : lowered);
}

export function extractBaseLocale(locale: string): string {
  try {
    return new Intl.Locale(locale.replace(/_/g, '-')).language;
  } catch {
    return locale.split('-')[0]?.toLowerCase() ?? '';
  }
}

export function getNativeLanguageName(code: string): string {
  try {
    return new Intl.DisplayNames([code], { type: 'language' }).of(code) ?? code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
}
